import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AboutUsComponent } from './about-us/about-us.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { JobsComponent } from './jobs/jobs.component';

const routes: Routes = [
  {
    path: 'about-us',
    component: AboutUsComponent,
    data: {
      title: 'About Us',
      description: 'About Us Description'
    }
  },
  {
    path: 'contact-us',
    component: ContactUsComponent,
    data: {
      title: 'Contact Us',
      description: 'Contact Us Description'
    }
  },
  {
    path: 'jobs',
    component: JobsComponent,
    data: {
      title: 'Jobs',
      description: 'Jobs Description'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OrganizationRoutingModule { }
